<div class="page-404">

  <div class="page-404__logo">
    <img [src]="'CP_logo.png'" />
  </div>

  <h1 class="page-404__code">404</h1>
  <h2 class="page-404__title">Oooops...</h2>
  <p class="page-404__subtitle">La pagina che cerchi non è disponibile</p>

  <div class="page-404__actions">
    <p-button
      routerLink=""
      type="button"
      class="sk-btn"
      label="Torna alla Dashboard"
    />
    <!-- <a
      href="https://www.checkpoint.app"
      class="sk-btn outline dark"
    >Vai al sito</a> -->
  </div>

  <footer class="page-404__footer">© 2026 - CheckPoint</footer>

</div>